import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { ApocalypseSoundNames } from "../../../../assetsLoader/ApocalypseAssetsNames";
import { ApocalypseFreespinOutroScreen } from "../freespin/ApocalypseFreespinOutroScreen";

export class ApocalypseSuperFreespinOutroScreen extends ApocalypseFreespinOutroScreen {
    constructor(parentContainer: AbstractView) {
        super(parentContainer, `ApocalypseSuperFreespinOutroScreen`);
    }

    protected getBackgroundMusicName(): string {
        return ApocalypseSoundNames.SUPER_FREESPIN_MUSIC;
    }

    // protected override getOutroWinSoundName(): string {
    //     return ApocalypseSoundNames.SFS_OUTRO_WIN;
    // }
}
